import { number, string } from "prop-types";

import styled from "styled-components/macro";
import { negitiveMargin } from "theme";

const SDiv = styled("div")`
  ${({ $color = "divider", $thickness = 1, theme: { colors, palette } }) => `
    border-bottom: ${$thickness}px solid ${
    colors[$color] || palette[$color] || $color
  };`}
  ${({ $marginX }) => ($marginX ? `margin: 0px ${$marginX}px;` : "")}
  ${negitiveMargin}
`;

/**
 *
 * @param {object} param0
 * @param {number} param0.thickness
 * @param {color} param0.color
 */
const FnrDivider = ({ thickness, color, marginX, ...rest }) => (
  <SDiv $thickness={thickness} $color={color} $marginX={marginX} {...rest} />
);

FnrDivider.propTypes = {
  thickness: number,
  color: string,
  marginX: number,
};

export default FnrDivider;
